import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';

@Pipe({
  name: 'headerTransform'
})
export class ProcedureAccordionsHeaderPipe implements PipeTransform {


  transform(fa: FormArray | { value: any, key: string }[][][] | AbstractControl, key: string, i: number, isContropartiFullName?: boolean, isNotSummary: boolean = true): string {
    //return null;
    if (isNotSummary && fa instanceof AbstractControl) {
      fa = fa as FormArray;
    }
    
    if (isNotSummary && fa instanceof FormArray) {
      const control: FormGroup = fa.at(i) as FormGroup;
      switch (key) {
        case 'intestatari':
        case 'richiedenti': {
          const v1 = (control.get('personaFisica').value == 'true' || control.get('personaFisica').value == true) &&
            control.get('nome').value ? '-' : null;
          const v2 = (control.get('personaFisica').value == 'true' || control.get('personaFisica').value == true) &&
            control.get('nome').value ? control.get('nome').value : null;

          const v3 = control.get('cognomeDenominazione').value ? (control.get('personaFisica').value &&
            control.get('nome').value ? null : '-') : null;

          const v4 = control.get('cognomeDenominazione').value ? control.get('cognomeDenominazione').value : null;

          const v5 = (control.get('personaFisica').value == 'true' || control.get('personaFisica').value == true) &&
            control.get('codiceFiscale').value
            ? '-'
            : null;

          const v6 = control.get('personaFisica').value == 'false' && control.get('partitaIva').value ? '-' : null;

          const v7 = control.get('personaFisica').value == 'true' || control.get('personaFisica').value == true
            ? control.get('codiceFiscale').value
            : control.get('partitaIva').value;
          return [v1, v2, v3, v4, v5, v6, v7].filter(val => val !== null).join(' ');
          //break;
        }
        case 'controparti': {
          return isContropartiFullName && control.get('cognomeDenominazione').value && control.get('nome').value
            ? ' - ' + control.get('nome').value + ' ' + control.get('cognomeDenominazione').value
            : isContropartiFullName && control.get('cognomeDenominazione').value
              ? ' - ' + control.get('cognomeDenominazione').value
              : isContropartiFullName && control.get('nome').value
                ? ' - ' + control.get('nome').value
                : !isContropartiFullName && control.get('cognomeDenominazione').value
                  ? ' - ' + control.get('cognomeDenominazione').value
                  : '';

        }

      }

    } else {
      const parisArray: { value: any, key: string }[][] = fa[i];
      const valueInArray: { value: any, key: string }[] = [];
      parisArray.forEach( val => {
        if(val[0]) valueInArray.push( val[0]);
        if(val[1]) valueInArray.push( val[1]);
      });
      const pFisica = valueInArray.find(val => val.key === 'personaFisica');
      const name = valueInArray.find(val => val.key === 'nome');
      let denomination = valueInArray.find(val => val.key === 'cognomeDenominazione');
      switch (key) {

        case 'intestatari':
        case 'richiedenti': {

          const CF = valueInArray.find(val => val.key === 'codiceFiscale');
          const PIVA = valueInArray.find(val => val.key === 'partitaIva');
//"APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.SI"
          const v1 = (pFisica && (pFisica.value == 'APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.SI' || pFisica.value == true)) && name &&
            name.value ? '-' : null;

          const v2 = pFisica && (pFisica.value == 'APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.SI' || pFisica.value == true) && name &&
            name.value ? name.value : null;


          const v3 = denomination && denomination.value ? (pFisica && pFisica.value && name &&
            name.value ? null : '-') : null;

          const v4 = denomination && denomination.value ? denomination.value : null;

          const v5 = pFisica && (pFisica.value == 'APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.SI' || pFisica.value == true) && CF &&
            CF.value
            ? '-'
            : null;

          const v6 = pFisica && pFisica.value == 'APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.NO' && PIVA && PIVA.value ? '-' : null;

          const v7 = pFisica && (pFisica.value == 'APPLICATION.FRONT_OFFICE.BASE_FORM.FISICA.SI' || pFisica.value == true) && CF
            ? CF.value
            : PIVA ? PIVA.value : null;
          return [v1, v2, v3, v4, v5, v6, v7].filter(val => val !== null).join(' ');
          //break;
        }
        case 'controparti': {
          denomination = valueInArray.find(val => val.key === 'denominazione');
          return isContropartiFullName && denomination && denomination.value && name && name.value
            ? ' - ' + name.value + ' ' + denomination.value
            : isContropartiFullName && denomination && denomination.value
              ? ' - ' + denomination.value
              : isContropartiFullName && name && name.value
                ? ' - ' + name.value
                : !isContropartiFullName && denomination && denomination.value
                  ? ' - ' + denomination.value
                  : '';

        }

      }

    }

  }

}

